import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, Sparkles } from 'lucide-react';
import { useAuth } from '../../store/auth.js';
import { initials } from '../../lib/format.js';
import { firstNameOf } from '../../lib/alertToggles.js';
import UserMenu from './UserMenu.jsx';

/**
 * "WELCOME, EASTON" pill + avatar. Opens the dropdown with the four alert
 * toggles (master / SMS / call / lead), the Light/Dark switch and Logout.
 * @returns {JSX.Element}
 */
export default function AccountMenu() {
  const { agent, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label="Account menu"
        data-testid="account-menu-trigger"
        className="flex items-center gap-2 rounded-lg hover:opacity-90 transition"
      >
        <span className="flex items-center gap-2 px-3 py-2 rounded-lg bg-civix-gradient text-white text-xs font-bold uppercase tracking-wide">
          <Sparkles className="w-3.5 h-3.5" />
          Welcome, {firstNameOf(agent) || 'Agent'}
        </span>
        <span className="w-9 h-9 rounded-full overflow-hidden bg-civix-gradient text-white flex items-center justify-center text-xs font-bold">
          {agent?.avatar ? <img src={agent.avatar} alt="" className="w-full h-full object-cover" /> : initials(agent?.name)}
        </span>
        <ChevronDown className={`w-3.5 h-3.5 text-white/50 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <UserMenu
        agent={agent}
        open={open}
        onClose={() => setOpen(false)}
        onLogout={() => { setOpen(false); logout(); nav('/login'); }}
      />
    </div>
  );
}
